import { Component, OnInit } from '@angular/core';
import { SelectedProductService } from '../main-content/sevices/selected-product.service';
import { CheckoutService } from './service/checkout.service';
import { AuthenticationService } from '../../app/_services/authentication.service';
import { NotificationService } from '../../app/_services/notification.service';
import { BehaviorSubject, combineLatest, Observable, ReplaySubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from '../../app/_models';
import { Router } from '@angular/router';
@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent implements OnInit {
  public allCarttems: any = [];
  private User: User;
  public mainCartItem: any = [];
  public CustomerDetails = { Name: '', Phone: '', Address: '', City: '', Pincode: '', State: '', District: 'Rajsamand', UserName: '', AddressType: 'Shipping', ShippingCharge: 10, Email:'420@mailinator.com' };
  public CustBillingaddress = { Name: '', Phone: '', Address: '', City: '', Pincode: '', State: '', District: '', UserName: '', AddressType: 'Billing' };
  PaymentInformation = { cardType: '2', Nameoncard: '', ExpMonth: '', ExpYear: '', CardNumber: '', CVV: '' }
  constructor(private selectedProductService: SelectedProductService, private http: HttpClient, private router: Router, private notifyService: NotificationService, private authService: AuthenticationService, private checkoutService: CheckoutService) { }

  ngOnInit(): void {
    debugger;
    this.User = this.authService.currentUserValue;
    this.allCarttems = this.selectedProductService.items;

    this.getTotal();
    debugger;

  }
  TotalOfAllItems = 0;
  getTotal() {
    this.TotalOfAllItems = 0;
    this.allCarttems.forEach(element => {
      this.TotalOfAllItems += parseFloat(element.Cost) * parseInt(element.selectedQuantity);
    });


  }


  sendEmailWithItems()
  {
     this.CustomerDetails.UserName = this.User.userName;
    this.mainCartItem = [];
    this.allCarttems.forEach(element => {
      this.mainCartItem.push({
        Cost: element.Cost,
        Image: element.ImagePath,
        PID: element.productId,
        ProductId: element.Id,
        ProductName: element.ProductName,
        ProductQuantity: element.Quantity,
        ProductcartDescription: "",
        Quantity: element.selectedQuantity,
        discount: element.Discount,
        productDescription: element.Description,
      })
    });

    var allDataToSend = {
      OrderCartItem: this.mainCartItem, CartTotal: this.TotalOfAllItems, OrderCustomerData: this.CustomerDetails, PaymentInfo: this.PaymentInformation, CustomerBillAddress:
        this.CustBillingaddress
    };
    this.checkoutService.shareOrder(allDataToSend).subscribe(res => {
      debugger;
      if (res.success == true) {
        debugger;
        this.notifyService.showSuccess("Your order has been placed and will be processed as soon as possible !!", "Succesfully Orderd");

      }
      else {
        this.notifyService.showError("Something wrong with your order", "Error");
      }
    })
  }

 private accessToken = 'EAAEXAMPLE9fG5YZAeJ3rZAZCCM3ZBZA2rUCZCy'; // Sample Access Token
  private phoneNumberId = '123456789012345'; // Sample Phone Number ID
  private apiUrl = `https://graph.facebook.com/v15.0/${this.phoneNumberId}/messages`;


  sendMessage(recipient: string, message: string): void {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json',
    });
    debugger;

    const body = {
      messaging_product: 'whatsapp',
      to: recipient,
      type: 'text',
      text: { body: message },
    };

    this.http.post(this.apiUrl, body, { headers }).subscribe(
      (response) => {
        console.log('Message sent successfully:', response);
      },
      (error) => {
        console.error('Error sending message:', error);
      }
    );
  }


  PlaceOrder() {
    debugger;
    
  
    this.CustomerDetails.UserName = this.User?.userName || 'motto';
    this.mainCartItem = [];
    this.allCarttems.forEach(element => {
      this.mainCartItem.push({
        Cost: element.Cost,
        Image: element.ImagePath,
        PID: element.productId,
        ProductId: element.Id,
        ProductName: element.ProductName,
        ProductQuantity: element.Quantity,
        ProductcartDescription: "",
        Quantity: element.selectedQuantity,
        discount: element.Discount,
        productDescription: element.Description,
      })
    });

    var allDataToSend = {
      OrderCartItem: this.mainCartItem, CartTotal: this.TotalOfAllItems, OrderCustomerData: this.CustomerDetails, PaymentInfo: this.PaymentInformation, CustomerBillAddress:
        this.CustBillingaddress
    };
    this.checkoutService.PostOrder(allDataToSend).subscribe(res => {
      debugger;
      if (res.success == true) {
        debugger;
        this.notifyService.showSuccess("Your order has been placed and will be processed as soon as possible !!", "Succesfully Orderd");
        localStorage.removeItem('items');
        this.selectedProductService.items;
        this.sendMessage('919001783675', 'Hello, this is a test message from Angular!');
        this.allCarttems = [];
        this.router.navigate(['/home']);
      }
      else {
        this.notifyService.showError("Something wrong with your order", "Error");
      }
    })
  }

}
